// extracted by mini-css-extract-plugin
module.exports = {"patners-grid":"Patners_patners-grid__1BAmV","patners-section":"Patners_patners-section__3QAXK","patner-title-container":"Patners_patner-title-container__18g8o"};